// Contract per MVPB-63 (BE: mflow-msa-mono, docs/fe-contracts/standalone-contract.md
// "Attachments"). Files live in Cloudflare R2, never in mFlow's own DB — the bucket is private,
// so `url` is a freshly-generated presigned GET on every read (currently 1h TTL). Do not
// persist/cache `url` beyond the current render — re-fetch the list to get a live one.
export interface StandaloneAttachment {
  _id: string;
  taskId: string;
  fileName: string;
  mimeType: string;
  size: number; // bytes
  url: string; // short-lived presigned download url
  authorSource?: 'human' | 'mcp_agent';
  clientName?: string;
  createdAt: number;
}

// Client-side mirror of the server's allowlist/cap (docs/fe-contracts/standalone-contract.md) —
// enforced server-side regardless; this is just to fail fast with a friendly message instead of
// spending a request on something the server will reject anyway.
export const MAX_ATTACHMENT_SIZE = 25 * 1024 * 1024;
export const ATTACHMENT_ACCEPT = '.png,.jpg,.jpeg,.gif,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.txt,.md,.csv';
